/* CNobre Store — policy display cleanup for Luxury */
(function () {
  'use strict';

  function cleanPolicyArtifacts() {
    /* CNobre Store — shipping policy timing alignment */
    if (window.location.pathname.indexOf('/policies/shipping-policy') !== -1) {
      document.querySelectorAll('.shopify-policy__body').forEach(function (root) {
        root.querySelectorAll('li, p').forEach(function (el) {
          Array.prototype.slice.call(el.childNodes).forEach(function (node) {
            if (node.nodeType !== Node.TEXT_NODE) return;
            node.textContent = node.textContent
              .replace(/10 a 30 dias úteis/g, '8 a 30 dias úteis')
              .replace(/10–30 dias úteis/g, '8–30 dias úteis');
          });
        });
      });
    }
    document.querySelectorAll('.shopify-policy__body').forEach(function (root) {
      root.querySelectorAll('div').forEach(function (el) {
        Array.prototype.slice.call(el.childNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '.') {
            node.remove();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanPolicyArtifacts, { once: true });
  } else {
    cleanPolicyArtifacts();
  }
})();
